const constant = {
    REQ_PARTNER_ORDER_UNPAIDORDER: 'partner.order.unpaidOrder',
    REQ_PARTNER_ORDER_CREATE: 'partner.order.create'
}

export default constant;
